import React, { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";
import { Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import { MOBILE_DISPLAY } from "../../../../constants";
import Icon from "@mdi/react";
import { mdiCloseCircleOutline } from "@mdi/js";
import NumberFormat from "react-number-format";

const GeoDataParcelle = (props) => {
   const [isLoading, setIsLoading] = useState(false);
   const [items, setItems] = useState([]);

   useEffect(() => {
      fetchData();
      fetchDataPreemption();
   }, [props.keypars]);

   const fetchData = () => {
      setIsLoading(true);

      const params = {
         key_parcelles: props.keypars,
      };
      axios
         .post("/Api/geodata/stat/parcelle", params)
         .then((result) => {
            setItems(result.data);
            setIsLoading(false);
            props.updateFormData("parcelles", result.data);
         })
         .catch((err) => {
            console.log(err);
            props.updateFormData("parcelles", []);
         });
   };

   const fetchDataPreemption = async () => {
      const params = {
         key_parcelles: props.keypars,
      };
      let result = await axios.post("/Api/geodata/stat/parcelle/preemption", params);
      let result2 = await axios.post("/Api/geodata/stat/com/preemption", params);

      result && result.data ? props.updateFormData("preemption", result.data) : props.updateFormData("preemption", []);
      result2 && result2.data
         ? props.updateFormData("preemption_com", result2.data)
         : props.updateFormData("preemption_com", []);
   };
   const handleRemoveParcelle = (id) => {
      props.removeParcelleFromList(id);
      props.removeFeature(id);
      $('[data-toggle="tooltip"]').tooltip("hide");
   };

   const getDetailPArcelle = (index) => {
      $('[data-toggle="tooltip"]').tooltip("hide");

      if (
         props?.currentEntity?.genre?.slug === "collective" &&
         (props?.isLeader === props?.currentEntity.id ||
            (props?.access && props.access.filter((e) => e.name === "relev_prop" && e.checked === true).length > 0))
      ) {
         props.showDetailParcelle(true, props.keypars && props.keypars[index] ? props.keypars[index] : null);
         props.showTab("detailParcelle");
      } else {
         Swal.fire({
            title: '<p style="color:var(--theme-color);">Information</p>',
            html: '<p style="font-size:50px;"><i class="bi bi-door-open text-danger"></i></p><p style="color:var(--theme-color);">Désolé,<br/>Votre statut actuel ne vous permet pas <br/> d\'accéder à cette section !</p>',
            background: props.uiTheme && props.uiTheme === "dark" ? "#454756" : "#d7dada",
            width: "19rem",
            showCancelButton: false,
            showConfirmButton: true,
            confirmButtonText: "Fermer",
            confirmButtonColor: "#35D5D5",
         });
      }
   };

   const builRow = (item, index) => {
      $('[data-toggle="tooltip"]').tooltip();

      return (
         <Fragment key={item.id}>
            <tr id={item.id} className={"text-center w-100"}>
               <td className="suppParcelle" id={item.id}>
                  <button
                     className="btn btn-outline-light btn-sm text-danger "
                     data-toggle="tooltip"
                     data-placement="top"
                     data-trigger="hover"
                     title="Supprimer"
                     style={{
                        backgroundColor: "#70979A",
                        height: "28px",
                        display: "flex",
                        alignItems: "center",
                        border: 'none',
                        margin: 10,
                     }}
                     onClick={() => {
                        handleRemoveParcelle(props.keypars[index]);
                     }}
                  >
                     <div
                        style={{
                           backgroundColor: "#F9F9F947",
                           borderRadius: "5px",
                        }}
                     >
                        <Icon
                           path={mdiCloseCircleOutline}
                           color="white"
                           style={{
                              backgroundColor: "red",
                              borderRadius: "7px",
                              width: "1rem",
                              height: "1rem",
                           }}
                        />
                     </div>
                  </button>
               </td>
               <td className="infoParcelle " id={item.id}>
                  <button
                     className="btn btn-sm "
                     data-toggle="tooltip"
                     data-placement="top"
                     data-trigger="hover"
                     title="Fiche descriptive de la parcelle"
                     onClick={() => getDetailPArcelle(index)}
                     style={{
                        backgroundColor: "#70979A",
                        height: "28px",
                        display: "flex",
                        alignItems: "center",
                     }}
                  >
                     <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        fill="#51F1D5"
                        className="bi bi-info-circle-fill"
                        viewBox="0 0 20 15"
                     >
                        <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2" />
                     </svg>
                     <span
                        className="text-center"
                        style={{
                           paddingLeft: "7px",
                           fontWeight: "700",
                        }}
                     >
                        DGFIP
                     </span>
                  </button>
               </td>
               {props.windowsSize > MOBILE_DISPLAY ? (
                  <td className={"d-none d-md-table-cell"}>{props.keypars[index]?.slice(0, 5) ?? null} </td>
               ) : null}
               <td>
                  <span className={"d-md-none font-weight-bold"}>Parcelle </span>
                  {props.keypars[index]?.slice(-6) ?? null}
               </td>
               {props.windowsSize > MOBILE_DISPLAY ? (
                  <td className={"d-none d-md-table-cell text-right"}>
                     <div className={"d-flex flex-row justify-content-around"}>
                        <NumberFormat
                           displayType={"text"}
                           thousandSeparator={" "}
                           value={item.pourcentage_bati > 1 ? Math.round(item.pourcentage_bati * 10) / 10 : "-"}
                        />
                        <NumberFormat
                           displayType={"text"}
                           thousandSeparator={" "}
                           value={item.surface_bati > 1 ? Math.round(item.surface_bati) : "-"}
                        />
                     </div>
                  </td>
               ) : null}

               <td className={"text-right"}>
                  <div className={"d-flex flex-row justify-content-around"}>
                     <NumberFormat displayType={"text"} thousandSeparator={" "} value={item.contenance} />
                     <span className={"d-md-none text-sm mr-2"}>ca</span>
                     <NumberFormat displayType={"text"} thousandSeparator={" "} value={Math.round(item.surface)} />
                     <span className={"d-md-none text-sm"}>
                        m<sup>2</sup>
                     </span>
                  </div>
               </td>
            </tr>
         </Fragment>
      );
   };

   return (
      <div className={"ueGeoDataSubpanel"}>
         {/*<div className={'ue-geodata-section-title'}>Cadastre </div>*/}
         <table id="table-refcad" className="table table-condensed  ue-table-data">
            {props.windowsSize > MOBILE_DISPLAY ? (
               <thead>
                  <tr className={"d-none d-md-table-row text-center"} style={{ color: "#70979A" }}>
                     <th width="5%">Supp</th>
                     <th width="5%">Propriétaire</th>
                     <th width="15%">Insee</th>
                     <th width="10%">Parcelle</th>
                     <th className={"text-right"}>
                        <div className={"d-flex flex-row justify-content-around"}>
                           <span>%</span> <span className={"font-weight-bold"}>Bâti Sol</span> <span>m</span>
                        </div>
                     </th>
                     <th className={"text-right"}>
                        <div className={"d-flex flex-row justify-content-around"}>
                           <span>Ca</span> <span className={"font-weight-bold"}>Surface</span> <span>m</span>
                        </div>
                     </th>
                  </tr>
               </thead>
            ) : null}
            <tbody className={"w-100"}>
               {isLoading ? (
                  <tr>
                     <td colSpan={props.windowsSize > MOBILE_DISPLAY ? "6" : "4"} className="text-center">
                        <Spinner animation="border" size={"sm"} />
                     </td>
                  </tr>
               ) : (
                  <Fragment>
                     {items.map((item, index) => {
                        return builRow(item, index);
                     })}
                     {items.length > 1 && props.windowsSize > MOBILE_DISPLAY ? (
                        <tr className={"d-none d-md-table-row font-weight-bold"}>
                           <td colSpan={3} className={"text-right"}>
                              <span className={"mr-3"}>Total :</span>
                           </td>
                           <td className={"text-center"}> {items.length}</td>
                           <td className={"text-right"}>
                              <div className={"d-flex flex-row justify-content-around"}>
                                 <div>
                                    {Math.round(_.meanBy(items, (item) => Number(item.pourcentage_bati)) * 10) / 10}
                                 </div>
                                 <div>{Math.round(_.sumBy(items, (item) => Number(item.surface_bati)))} </div>
                              </div>
                           </td>
                           <td className={"text-right"}>
                              <div className={"d-flex flex-row justify-content-around"}>
                                 <NumberFormat
                                    displayType={"text"}
                                    thousandSeparator={" "}
                                    value={Math.round(_.sumBy(items, (item) => Number(item.contenance)))}
                                 />
                                 <NumberFormat
                                    displayType={"text"}
                                    thousandSeparator={" "}
                                    value={Math.round(_.sumBy(items, (item) => Number(item.surface)))}
                                 />
                              </div>
                           </td>
                        </tr>
                     ) : null}
                  </Fragment>
               )}
            </tbody>
         </table>
      </div>
   );
};

const mapStateToProps = (state) => {
   return {
      currentEntity: state.MeReducer.entity,
      userSubscription: state.MeReducer.subscription,
      uiTheme: state.AppReducer.uiTheme,
      windowsSize: state.AppReducer.windowsSize,
      isLeader: state.MeReducer.isLeader,
      access: state.MeReducer?.prefs?.access,
   };
};

const mapDispatchTProps = (dispatch) => {
   return {
      removeParcelleFromList: (e) =>
         dispatch({
            type: "REMOVE_PARCELLE_FROM_LIST",
            data: { parcelleCode: e },
         }),
      removeFeature: (e) => dispatch({ type: "REMOVE_FEATURE", data: { featureId: e } }),
      updateFormData: (k, e) => dispatch({ type: "UPDATE_FORM_DATA", data: { key: k, data: e } }),
      showDetailParcelle: (e, d) =>
         dispatch({
            type: "TOGGLE_SHOW_DETAIL_PARCELLE",
            data: { showDetailParcelle: e, keypar: d },
         }),
      showTab: (e) => dispatch({ type: "TOGGLE_PANEL_TAB", data: { currentTab: e } }),
   };
};

export default connect(mapStateToProps, mapDispatchTProps)(GeoDataParcelle);
